import { motion } from "framer-motion";
import config from "../utils/config";
import { CircleX } from 'lucide-react';

export default function WorkflowError({ onClose }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="relative max-w-md mx-auto rounded-2xl p-6 flex flex-col items-center text-center"
    >
      {/* Close Button */}
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-xl font-bold">
          <CircleX color="#0056d6" strokeWidth={1.5} />
        </button>
      )}

      {/* Illustration */}
      <img
        src={`${config.IMG_URL}/wonder_tuly.png`}
        alt="Error Illustration"
        className="w-13 h-13 mb-4"
      />

      {/* Message Content */}
      <h3 className="text-lg font-semibold text-red-700">Prompt issue!</h3>
      <p className="text-black-700 mt-2 text-sm leading-relaxed">
        It looks like your workflow prompt is very long and descriptive.  
        Please try making it more concise and specific so we can generate  
        a clearer and more complete workflow result.
      </p>
    </motion.div>
  );
}
